import "react";
import { css as e, styled as t } from "styled-components";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import * as i from "@radix-ui/react-dropdown-menu";
//#region src/components/DropdownMenu/DropdownMenuItems.tsx
var a = e`
    display: flex;
    align-items: center;
    gap: ${({ theme: e }) => e.spacing(1.5)};
    padding: ${({ theme: e }) => `${e.spacing(1)} ${e.spacing(2)}`};
    border-radius: ${({ theme: e }) => e.radii.sm};
    font-family: ${({ theme: e }) => e.typographyTokens.fontFamily};
    font-size: ${({ theme: e }) => e.typographyTokens.sizes.sm};
    color: ${({ theme: e }) => e.colors.foreground};
    cursor: pointer;
    outline: none;
    user-select: none;
    transition: background-color ${({ theme: e }) => e.transitions.fast};
    border: none;
    background: none;
    width: 100%;
    text-align: left;

    &[data-highlighted] {
        background-color: ${({ theme: e }) => e.colors.accent};
        color: ${({ theme: e }) => e.colors.accentForeground};
    }

    &[data-disabled] {
        opacity: 0.4;
        cursor: not-allowed;
        pointer-events: none;
    }

    @media (max-width: 768px) {
        padding: ${({ theme: e }) => `${e.spacing(2)} ${e.spacing(3)}`};
        font-size: ${({ theme: e }) => e.typographyTokens.sizes.base};
    }
`, o = t(i.Item)`
    ${a}
`, s = t(i.SubTrigger)`
    ${a}
`, c = t(i.CheckboxItem)`
    ${a}
    padding-left: ${({ theme: e }) => e.spacing(4)};
    position: relative;

    @media (max-width: 768px) {
        padding-left: ${({ theme: e }) => e.spacing(5)};
    }
`, l = t(i.ItemIndicator)`
    position: absolute;
    left: ${({ theme: e }) => e.spacing(2)};
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${({ theme: e }) => e.colors.primary};

    @media (max-width: 768px) {
        left: ${({ theme: e }) => e.spacing(2.5)};
    }
`, u = t(i.RadioItem)`
    ${a}
    padding-left: ${({ theme: e }) => e.spacing(4)};
    position: relative;

    @media (max-width: 768px) {
        padding-left: ${({ theme: e }) => e.spacing(5)};
    }
`, d = t(i.Label)`
    padding: ${({ theme: e }) => `${e.spacing(.5)} ${e.spacing(2)}`};
    font-family: ${({ theme: e }) => e.typographyTokens.fontFamily};
    font-size: ${({ theme: e }) => e.typographyTokens.sizes.xs};
    font-weight: ${({ theme: e }) => e.typographyTokens.weights.semibold};
    color: ${({ theme: e }) => e.colors.mutedForeground};
    text-transform: uppercase;
    letter-spacing: 0.05em;

    @media (max-width: 768px) {
        padding: ${({ theme: e }) => `${e.spacing(1.5)} ${e.spacing(3)}`};
        font-size: ${({ theme: e }) => e.typographyTokens.sizes.sm};
    }
`, f = t(i.Separator)`
    height: 1px;
    background-color: ${({ theme: e }) => e.colors.border};
    margin: ${({ theme: e }) => e.spacing(.5)} 0;

    @media (max-width: 768px) {
        margin: ${({ theme: e }) => e.spacing(1)} 0;
    }
`, p = t.span`
    margin-left: auto;
    padding-left: ${({ theme: e }) => e.spacing(3)};
    font-size: ${({ theme: e }) => e.typographyTokens.sizes.xs};
    color: ${({ theme: e }) => e.colors.mutedForeground};

    @media (max-width: 768px) {
        font-size: ${({ theme: e }) => e.typographyTokens.sizes.sm};
    }
`, m = () => /* @__PURE__ */ n("svg", {
	width: "12",
	height: "12",
	viewBox: "0 0 12 12",
	fill: "none",
	children: /* @__PURE__ */ n("path", {
		d: "M4 2l4 4-4 4",
		stroke: "currentColor",
		strokeWidth: "1.5",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), h = () => /* @__PURE__ */ n("svg", {
	width: "12",
	height: "12",
	viewBox: "0 0 12 12",
	fill: "none",
	children: /* @__PURE__ */ n("path", {
		d: "M2 6l3 3 5-5",
		stroke: "currentColor",
		strokeWidth: "1.5",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), g = ({ children: e, shortcut: t, ...i }) => /* @__PURE__ */ r(o, {
	...i,
	children: [e, t && /* @__PURE__ */ n(p, { children: t })]
}), _ = ({ children: e, ...t }) => /* @__PURE__ */ r(s, {
	...t,
	children: [e, /* @__PURE__ */ n(p, { children: /* @__PURE__ */ n(m, {}) })]
}), v = ({ children: e, ...t }) => /* @__PURE__ */ r(c, {
	...t,
	children: [/* @__PURE__ */ n(l, { children: /* @__PURE__ */ n(h, {}) }), e]
}), y = ({ children: e, ...t }) => /* @__PURE__ */ r(u, {
	...t,
	children: [/* @__PURE__ */ n(l, { children: /* @__PURE__ */ n("svg", {
		width: "8",
		height: "8",
		viewBox: "0 0 8 8",
		fill: "currentColor",
		children: /* @__PURE__ */ n("circle", {
			cx: "4",
			cy: "4",
			r: "4"
		})
	}) }), e]
}), b = (e) => /* @__PURE__ */ n(d, { ...e }), x = (e) => /* @__PURE__ */ n(f, { ...e });
//#endregion
export { v as DropdownMenuCheckboxItem, g as DropdownMenuItem, b as DropdownMenuLabel, y as DropdownMenuRadioItem, x as DropdownMenuSeparator, _ as DropdownMenuSubTrigger };
